import React, { useState } from "react";

const TextField = ({
  dataTestId,
  placeholder,
  error,
  name,
  type,
  width,
  value,
  margin,
  handleChange,
  icon,
  max,
  min,
  comment,
  autoComplete,
  register,
}) => {
  const [isVisible, setIsVisible] = useState(false);
  const isEnhancedContrast = window.enhancedContrast;

  return (
    <div
      className="input-container"
      style={{
        width: width == "full" ? "100%" : `calc(${width == "half" ? 50 : width}% - 6px)`,
        marginRight: margin ? "12px" : "0px",
        backgroundColor: "transparent",
      }}
    >
      <div
        className={`input input--text ${error && "input--error"} ${isEnhancedContrast && "enhancedContrast"} ${isEnhancedContrast && error && "enhancedContrast__error"}`}
      >
        <input
          data-testid={dataTestId}
          maxLength={max}
          max={max}
          min={min}
          className="styledInput"
          autoComplete={autoComplete}
          type={type}
          name={name}
          id={name}
          value={value}
          {...register(name)}
          onChange={(name) => {
            handleChange(name);
          }}
        />
        <label
          htmlFor={name}
          className={`styledLabel ${value.length > 0 && "styledLabel--active"} ${isEnhancedContrast && "styledLabel__enhancedContrast"}`}
        >
          {placeholder}
        </label>

        {icon && (
          <div
            className="input__img"
            onClick={() => {
              if (window.isMobile) {
                setIsVisible(!isVisible);
              }
            }}
            style={{
              backgroundImage: `url(${icon}`,
            }}
          >
            {comment && (
              <span className="input__comment" visible={isVisible.toString()}>
                {comment}
              </span>
            )}
          </div>
        )}
      </div>
      {error && <span className="formError">{error}</span>}
    </div>
  );
};

export default TextField;
